import React, { Component } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';

// eslint-disable-next-line
import style from './_style.css';

class BlueButton extends Component {
    render() {
        const { noValid } = this.props;
        return (
            <Button
                disabled={this.props.disabled}
                variant="contained"
                onClick={this.props.onClick}
                className={classNames('bluebutton hand', noValid ? 'bg_lipstick' : 'bg_bluish', this.props.className)}
            >
                <span className={'barlow_semibold c_white'}>
                    <FormattedMessage id={this.props.id} />
                </span>
            </Button>
        );
    }
}

export default BlueButton;



// WEBPACK FOOTER //
// ./src/components/buttons/BlueButton.js